module.exports = __webpack_public_path__ + "img/tuoyuMa.7f155a6f.jpg";